var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTiktokDesktopSocialFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  viewBox: "0 0 22 22",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 11,
  r: 11,
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1877F2",
  d: "M22 10.995C22 4.923 17.075 0 11 0S0 4.923 0 10.995c0 5.488 4.023 10.037 9.281 10.862v-7.684H6.488v-3.178h2.793V8.573c0-2.756 1.643-4.278 4.155-4.278 1.203 0 2.462.215 2.462.215v2.706h-1.387c-1.366 0-1.792.847-1.792 1.717v2.062h3.05l-.487 3.178h-2.563v7.684C17.978 21.032 22 16.483 22 10.995"
}))));
export default SvgTiktokDesktopSocialFacebook;